import { render, staticRenderFns } from "./Bando28Fase2.vue?vue&type=template&id=7275a5d0&scoped=true"
import script from "./Bando28Fase2.vue?vue&type=script&lang=js"
export * from "./Bando28Fase2.vue?vue&type=script&lang=js"
import style0 from "./Bando28Fase2.vue?vue&type=style&index=0&id=7275a5d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275a5d0",
  null
  
)

export default component.exports